import React from 'react';
import "styles/components/menu/company/IntroduceTab.scss";

const Introduce = () => {
    return (
        <section className='IntroduceTab'>
            <div className="IntroduceTab-wrapper">
                <p>
                    <span className='fw_bold'>어질인소프트(주)</span>는<br className='lineBreak' />
                    차별화된 소프트웨어 기술력과 창의력을 기반으로 <br className='lineBreak pc' /><span className='fw_bold'>2015년 창업 이후 </span><br className='lineBreak mobile' />
                    <span className='fw_bold'>끊임없는 도전과 혁신으로 <br className='lineBreak pc' />성장하고 있는 IT 전문 기업</span>입니다<br className='lineBreak' />
                </p>
                <p>
                    자사는 <span className='fw_bold'>직원과 고객, 그리고 지역사회와의 상생</span>을 <br className='lineBreak pc' />가장 큰 핵심가치로 두고 있으며<br className='lineBreak' />
                    직원, 회사, 고객, 지역사회 <span className='fw_bold'>모두의 이익을 추구</span>합니다<br className='lineBreak' />
                </p>
                <p>
                    앞으로도 지속적인 변화를 통해 <br className='lineBreak pc' />더욱 <span className='fw_bold'>전문적이고 세분된 기술과 서비스</span>로<br className='lineBreak' />
                    <span className='fw_bold'>고객의 비즈니스 가치를 높이는 데 매진</span>하겠습니다<br className='lineBreak' />
                </p>
                <p>
                    끊임없는 <span className='fw_bold'>변화와 혁신으로 IT 서비스 산업에 중심</span>이 되어<br className='lineBreak' />
                    <span className='fw_bold'>고객에게 다가가는 어질인소프트가 될 것을 약속</span>드립니다<br className='lineBreak' />
                </p>
            </div>
        </section>
    );
};

export default React.memo(Introduce);